import { DayHeaderContentArg } from '@fullcalendar/core';
import { format } from 'date-fns';
import React from 'react';

import * as Styled from './date-header.style';

export const DateHeader: React.FC<DayHeaderContentArg> = ({
  date,
  isToday,
}) => (
  <Styled.DateHeaderContainer $isToday={isToday}>
    {format(date, 'EEE')}
    <Styled.CalendarDayBadge $isToday={isToday}>
      {format(date, 'd')}
    </Styled.CalendarDayBadge>
  </Styled.DateHeaderContainer>
);
